import React, { useState } from 'react';

import { useLayoutEffect } from 'common/hooks/useIsomorphicLayoutEffect';

import { calculatePaddingBottom, calculatePaddingTop } from '../utils/utils';

export const useFindPaddings = (
  schemeElement: React.RefObject<HTMLDivElement>,
  itemsLength: number,
  isReversed: boolean,
) => {
  const [paddingTop, setPaddingTop] = useState(0);
  const [paddingBottom, setPaddingBottom] = useState(0);

  useLayoutEffect(() => {
    function setPaddings() {
      setPaddingTop(calculatePaddingTop(schemeElement?.current!, itemsLength, isReversed));
      setPaddingBottom(calculatePaddingBottom(schemeElement?.current!, itemsLength, isReversed));
    }

    if (schemeElement?.current) {
      setPaddings();

      window.addEventListener('resize', setPaddings);

      return () => {
        window.removeEventListener('resize', setPaddings);
      };
    }
  }, []);

  return [paddingTop, paddingBottom];
};
